<div class="common-wrapper">
    <div class="main-hd-txt">
        <span>
            <h4>MEETING GROUP<span class="head-btn-style">
                    <button *ngIf="!listView" (click)="goToBackTab()" class="go-back-btn-head" title="Back Tab">
                        <i class="bi bi-arrow-left-circle"></i> Back</button></span><span class="head-btn-style">
                    <button *ngIf="!listView" (click)="save($event)" class="save-btn-head" [disabled]="saveDisabled"
                        title="Save">
                        <i class="bi bi-file-earmark-plus"></i> Save</button></span></h4>
        </span>
    </div>
    <div *ngIf="listView" class="top-btns">
        <grid [entities]="Meetingtype" [actionExclude]="['delete','feedback','column']" [checkboxCol]="true"
            [entityColumns]="MeetingtypeColumns" [selectionField]="'MeetingType_Id'"
            [addEntityIcon]="'bi bi-plus-square'" [addEntityCaption]="'Add'" [downloadEntityCaption]="'Download'"
            (addEntity)="addMeetingtype($event)" (downloadEntities)="onExcelExport()"
            (editEntity)="editMeetingtype($event)" (refreshEntities)="refreshMeetingType($event)"
            (deleteEntity)="deleteMeetingtype($event)" (onPaginationChange)="onPaginationChange($event)"
            [serverPagination]="true" [pageSizes]="pageSizes" [pageSize]="defaultPageSize" [skip]="pageSkip"
            (onFilterChange)="onFilterChange($event)">
        </grid>

    </div>

    <div *ngIf="!listView">
        <div class="row sub-head">
            <div class="col-md-7 text-bold">
                {{ formCaption }}
            </div>
            <div class="col-md-5 text-end">
                <button (click)="clearMeetingtype()" class="btn-3 bt-3-ic"><span>Clear</span></button>
                <button (click)="revertChanges()" class="btn-3 bt-4-ic"><span>Revert Changes</span></button>
                <button (click)="gotoBack()" class="btn-3 bt-4-ic"><span>Go Back</span></button>
            </div>
        </div>

        <div class="col-md-12 content-area">
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Code'" [formData]="entity" [maxlength]="10" [mandatory]="true"
                        [fieldName]="'Code'" [(ngModel)]="entity.Code" id="txt_MeetingType_code" ngDefaultControl>
                    </textbox>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Meeting Group Name'" [formData]="entity" [maxlength]="50" [mandatory]="true"
                        [fieldName]="'MeetingTypeName'" [(ngModel)]="entity.MeetingTypeName " ngDefaultControl>
                    </textbox>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Meeting Group Access'" [formData]="entity" [data]="typeaccess"
                        [class]="'form-control'" [mandatory]="true" [filterable]="true"
                        (filterChanged)="getallMeetingTypeAccess($event)" [textField]="'DisplayText'"
                        [valueField]="'DisplayValue'" [fieldName]="'MeetingTypeAccess'"
                        (selectionChanged)="getallMeetingTypeAccess('')" [selectedItem]="selectedMeetingTypeAccess"
                        [(ngModel)]="entity.MeetingTypeAccess" ngDefaultControl>
                    </dropdown>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Description'" [multiline]="true" [formData]="entity" [maxlength]="500"
                        [mandatory]="false" [fieldName]="'MeetingtypeDescription'"
                        [(ngModel)]="entity.MeetingtypeDescription" ngDefaultControl>
                    </textbox>
                </div>
            </div>


            <div class="row">
                <div class="col-md-4 mb-2">
                    <checkbox [caption]="' Active'" [(ngModel)]="entity.IsActive"></checkbox>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-md-1">
                    <btn [label]="'Back'" (click)="goToBackTab()" [class]="'btn-next btn-11'" [type]="'button'"
                        title="Back Tab"></btn>
                </div>
                <div class="col-md-4 mb-2">
                    <btn [label]="'Save'" (click)="save($event)" [class]="'btn-1 btn-11'" [disabled]="saveDisabled"
                        [type]="'button'"></btn>
                </div>
            </div> -->
        </div>

    </div>
</div>
<ng-template #view let-dataItem let-rowIndex="rowIndex">
    <i class="bi bi-eye-fill" (click)="open(dataItem)"></i>
</ng-template>
<kendo-dialog title="Meeting Group Details" *ngIf="opened" (close)="close()" [height]="500" [width]="1000">
    <div class="col-md-12 content-area">
        <div class="row">
            <div class="col-md-4 br-table-data">
                <label for="Code" class="label label-1">Code : </label> {{details.Code}}
            </div>
            <div class="col-md-4 br-table-data">
                <label for="MeetingTypeName" class="label label-1">Meeting Group : </label> {{details.MeetingTypeName }}
            </div>
                       <div class="col-md-4 br-table-data">
                <label for="MeetingTypeAccess" class="label label-1">Meeting Group Access : </label>{{details.DisplayText}}
            </div>
            <div class="col-md-4 br-table-data">
                <label for="MeetingtypeDescription" class="label label-1">Description : </label>
                {{details.MeetingtypeDescription}}
            </div>
        </div>
    </div>
</kendo-dialog>
<kendo-excelexport [data]="Meetingtype.data" [collapsible]="true" fileName="MeetingGroupMaster.xlsx" #excelexport>
    <kendo-excelexport-column field="SlNo" title="Sl.No." [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="MeetingTypeName" title="Meeting Group" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="Code" title="Code" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="MeetingtypeDescription" title="Description" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="Active" title="Active" [width]="200">
    </kendo-excelexport-column>
</kendo-excelexport>